import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-add-three-sixty-review-popup',
  templateUrl: './add-three-sixty-review-popup.component.html',
  styleUrls: ['./add-three-sixty-review-popup.component.scss'],
})
export class AddThreeSixtyReviewPopupComponent  implements OnInit {
  externalUser = [
    {
      name: '',
      companyName: '',
      email: '',
      id: null,
      review360Id: null
    },
  ];
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  buttonColorName:any;
  popupName:any;
  selectedReviewID:any;
  reviewUserId:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
  public dialogRef: MatDialogRef<AddThreeSixtyReviewPopupComponent>,private toastr:ToastrService) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.popupName = this.data?.popupName;
    this.selectedReviewID = this.data?.selectedReviewID;
    this.externalUser = this.data?.data;
    this.reviewUserId = this.data?.reviewUserId;
    if(this.externalUser.length==0){
      this.externalUser = [{
        name: '',
        companyName: '',
        email: '',
        id: null,
        review360Id: this.selectedReviewID
      }]
    }
  }


  createExtUserAddTableRow() {
    this.externalUser.push({
      name: '',
      companyName: '',
      email: '',
      id: null,
      review360Id: this.selectedReviewID
    });
  }

  createExtUserRemoveTableRow(index: number) {
    if (this.externalUser.length > 1) {
      this.externalUser.splice(index, 1);
    }
  }

  isEdit(){
    this.popupName = 'addPopup'
  }
  onClickSave(){
    var flag = true;
    if(this.externalUser?.some((ele: any) => 
      ele.name == '' || ele.companyName == '' || ele.email == '')){ flag = false}
    if(flag){
      let data = {
        externalUser: this.externalUser,
        reviewUserId: this.reviewUserId
      }
      this.dialogRef.close(data);
    }else{
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000,
      });
    }
  }
}
